import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { IContainerForm } from '@/types';
import { Title } from '@/components';
import { transformArrayAttributes } from '@/utils';
import { VContainer, VFlex, VLayout } from 'vuetify/lib';

@Component({
  name: 'ContainerForm',
})
export default class ContainerForm extends Vue implements IContainerForm {
  @Prop({type: String}) public readonly subTitle!: string;
  @Prop({type: Object}) public readonly customCardStyle!: {};
  @Prop({type: Number}) public readonly timeout!: number;

  public clickHandler: any;
  public close: boolean = false;

  private render(createElement: CreateElement): VNode {

    const subTitle: VNode = createElement(Title, {
      props: {
        size: 18,
        text: this.subTitle,
      },
    });
    const flex: VNode = createElement('form', {
      class: [
        transformArrayAttributes(['flex-column', 'flex-center', 'container-form']),
        this.$vuetify.breakpoint.xsOnly ? 'container-form-mobile' : 'container-form-desktop',
      ],
      style: {
        ...this.customCardStyle,
      },
    }, [this.$slots.default, subTitle]);

    const subContainer = createElement(VFlex, {
      class: transformArrayAttributes(['flex-center', 'flex-column']),
      style: {
        width: 'inherit',
      },
    }, [flex]);

    const layout: VNode = createElement(VLayout, {
      class: transformArrayAttributes(['flex-column']),
      style: {
        maxWidth: '500px',
        position: 'relative',
      },
    }, [
      this.$slots.over,
      this.$slots.overHeader,
      subContainer,
    ]);

    const container: VNode = createElement(VContainer, {
      attrs: {
        fluid: true,
      },
      class: [
        transformArrayAttributes([
        'flex',
        'align-center',
        'flex-column',
        'container-wrapper',
      ]),
      this.$vuetify.breakpoint.xsOnly
        ? 'wrapper__mobile'
        : 'wrapper__desktop',
    ],
    }, [
      this.$slots.title,
      layout,
      this.$slots.bottom,
    ]);

    return container;
  }

  private mounted(): void {
    this.clickHandler = (event) => {
      if (event.key === 'Enter') {
        const buttons = document.getElementsByClassName('orange-big-button');
        if (buttons.length === 1) {
          (buttons as any).item(0).click();
        }
      }
    },

    document.addEventListener('keyup', this.clickHandler);
  }

  private destroyed(): void {
    document.removeEventListener('keyup', this.clickHandler);
  }
}
